// tosPorUsuario.js
//
// UNA sola fuente del texto de los Términos. Lo usan:
//  - TosAcceptanceGate (el texto que el médico acepta con la casilla);
//  - TermsAndConditions (la página pública /terms-and-conditions, a la que
//    enlazan el gate y la Política de Privacidad).
//
// POR QUÉ (revisor externo, 02-oct-2026, ronda 2, NB1, Planner 347): la ruta
// /terms-and-conditions mostraba otra página escrita a mano (badges "Estándar
// Ley 21.719", "solo bajo nuestra instrucción", art. 127 CS, audio "sin pasar
// por nuestros servidores", tope de 3 meses) que contradecía el texto aceptado
// y la política. Un fiscalizador que hace clic en el enlace de la política leía
// lo que la v1.2 retira. Con un solo renderer no puede volver a divergir.
import { getTosMarkdown, TOS_VERSION_VIGENTE, TOS_VERSION_VIGENTE_INTERNO } from "./tosContent";
import { getTosInternoMarkdown } from "./tosContentInterno";

// #1738 R10: el estudiante firma la misma versión que el interno (Tipo C).
const esTipoC = (user) => ["INTERNO", "ESTUDIANTE"].includes(user?.professional_profile?.profession);

// Un interno no acepta el mismo documento que un médico habilitado (R38 v5,
// 28-sep-2026). Sin usuario (visitante de la página pública) se muestra el
// Tipo A, que es el que ve quien se registra (AuthenticationForm).
export const tosMarkdownFor = (user, version) =>
  esTipoC(user) ? getTosInternoMarkdown(version) : getTosMarkdown(version);

// La versión que pide el backend (/api/user/me/). Sin sesión, la vigente: una versión vacía
// caería en el texto congelado de la v1.x (tosVersionesAnteriores.js), y la página pública,
// adonde enlaza la política, mostraría lo que la v2.0 retira (revisor del bump, 20-oct, A1).
export const tosVersionFor = (user) =>
  user?.current_tos_version ||
  user?.tos_accepted_version ||
  (esTipoC(user) ? TOS_VERSION_VIGENTE_INTERNO : TOS_VERSION_VIGENTE);
